import { useAidResults } from '../../../hooks/use-aid-results';
import { buildMetrics } from './use-compare-estimates';

import type { ComparisonMetric } from './use-compare-estimates';

export interface UseComparisonRowResultsResult {
  metrics: ComparisonMetric[];
  isLoading: boolean;
}

// Shared by the version-select cell (for its disabled/loading state) and each
// metric cell in a comparison row — both need the same query, and React Query
// dedupes identical queryKeys across call sites, so this never double-fetches.
export const useComparisonRowResults = (
  userId: string,
  selectedVersionId: number | undefined
): UseComparisonRowResultsResult => {
  const resultsQuery = useAidResults({
    userId,
    modelId: selectedVersionId ? String(selectedVersionId) : '',
    enabled: !!selectedVersionId,
  });

  return {
    metrics: buildMetrics(resultsQuery.data?.estimatedResults?.totalFirstYear),
    isLoading: resultsQuery.isLoading && !!selectedVersionId,
  };
};
